import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 48px;
`;

export const SubTitle = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
`;

export const Entry = styled.div`
    margin-bottom: 2em;

    .heading {
        a {
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            margin: 1em 0px 0px;
        }
    }
`;
